import { render, staticRenderFns } from "./AddDoctor.vue?vue&type=template&id=6fc84043&scoped=true"
import script from "./AddDoctor.vue?vue&type=script&lang=js"
export * from "./AddDoctor.vue?vue&type=script&lang=js"
import style0 from "./AddDoctor.vue?vue&type=style&index=0&id=6fc84043&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc84043",
  null
  
)

export default component.exports